import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";

interface IAddItem {
  newValue: (value: string) => void;
}

const AddItem = ({ newValue }: IAddItem) => {
  const [newItem, setNewitem] = useState<string>("");

  const addValue = (e: any) => {
    e.preventDefault();
    if (newItem) {
      newValue(newItem);
      setNewitem("");
    }
  };

  return (
    <>
      <form className="grid" onSubmit={addValue}>
        <div className="col-11">
          <InputText
            value={newItem}
            onChange={(e) => setNewitem(e.target.value)}
          />
        </div>
        <div className="col-1 flex justify-content-end">
          <Button
            icon="pi pi-plus"
            className="p-button p-button-text"
            type="submit"
          />
        </div>
      </form>
    </>
  );
};

export default AddItem;
